import { Button } from "@mui/material";

export default function Year2025() {
  return (
    <div className="history2021">
      <div>
        <h1>Türkiye 30. Zeka Oyunları Yarışması</h1>
        <h2>
          <strong>OYUN 2025'in Sonuçları Açıklandı!</strong>
        </h2>
      </div>

      <div>
        <img
          style={{ maxWidth: 800, width: "100%" }}
          src="/assets/images/oyun-2025-final.png"
        />
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Türkiye 30. Zeka Oyunları Yarışması “Oyun 2025” final sınavı ODTÜ'de
          gerçekleşti.
        </h3>
        <p style={{ textAlign: "left" }}>
          8 Kasım 2025 tarihinde, Türkiye Zeka Vakfı tarafından Logo Yazılım’ın
          ana sponsorluğunda ve Yamantürk Vakfı’nın desteğiyle düzenlenen 30.
          Türkiye Zeka Oyunları Yarışması, ODTÜ Eğitim Fakültesi’nde yapılan
          final sınavı ve ödül töreniyle sona erdi. Türkiye’nin dört bir
          yanından gelen finalistler sınava katıldı.
        </p>
        {/* <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Okuma-yazma ve dört işlem becerileri ile geçen bir cumartesi
        </h3> */}
        <p style={{ textAlign: "left" }}>
          Sözel, sayısal, görsel ve mantık alanlarında hazırlanan özgün
          sorularla donatılan bu büyük final; “Minikler”, “Çocuklar”, “Gençler”,
          “Yetişkinler” ve “Emektarlar” kategorilerinde yapıldı. Yarışma boyunca
          her yaş grubundan katılımcı, sınav süresince farklı düşünme
          becerilerini sınama fırsatı buldu.
        </p>
        {/* <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Yediden yetmişe değil, beşten yetmiş sekize
        </h3> */}
        <p style={{ textAlign: "left" }}>
          Final sınavı, sabah saat 11.00’da tüm kategoriler için başladı ve
          12.00’da sona erdi. Sınavın ardından, yarışmacıların sınav kağıtları
          değerlendirilerek kazananlar belirlendi. Saat 16.30’da ODTÜ Eğitim
          Fakültesi Çok Amaçlı Konferans Salonunda gerçekleştirilen ödül
          töreniyle dereceye giren yarışmacılar başarılarını taçlandırdı.
        </p>

        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          81 İlden Gelen Katılımla Gerçek Bir Türkiye Mozaiği
        </h3>
        <p style={{ textAlign: "left" }}>
          OYUN 2025’e bu yıl da 81 ilden yoğun bir ilgi vardı. Final sürecine
          katılan yarışmacılar arasında, daha önce bu deneyimi yaşayan ve
          ODTÜ’yle ilk kez tanışan birçok isim de yer aldı. Bu tanışıklığın bazı
          yarışmacılara üniversite tercihlerinde yön verdiği gözlemlendi.
        </p>
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>Ödül töreni</h3>
        <p style={{ textAlign: "left" }}>
          Ödül töreninde Türkiye Zeka Vakfı Başkanı Emrehan Halıcı, 30 yıldır
          süregelen bu köklü organizasyonun değerini ve ülke genelinde yarattığı
          farkındalığı vurgulayan bir konuşma gerçekleştirdi. Tüm finalistler
          tek tek tebrik edildi, başarıları alkışlandı.
        </p>
        <img
          style={{ maxWidth: 800, width: "100%" }}
          src="/assets/images/oyun-2025-odul.png"
        />

        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Şeref Kürsüsünde Başarı Öyküleri
        </h3>
        <p style={{ textAlign: "left" }}>
          Her kategoride dereceye giren yarışmacıların kısa özgeçmişleri ve
          fotoğrafları, “Şeref Kürsüsü” sayfasında yayınlanacaktır.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {/* <Button
          color="secondary"
          style={{
            marginLeft: 3,
            marginRight: 3,
            marginBottom: 6,
          }}
          variant="contained"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://halici.pixieset.com/oyun2023/"
            style={{ color: "white", textDecoration: "none" }}
          >
            Fotoğraf Galerisi
          </a>
        </Button> */}
        <Button
          color="secondary"
          style={{
            marginLeft: 3,
            marginRight: 3,
            marginBottom: 6,
          }}
          variant="contained"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://oyun.tzv.org.tr/hall_of_fame"
            style={{ color: "white", textDecoration: "none" }}
          >
            Dereceye Giren Yarışmacılar
          </a>
        </Button>
      </div>
    </div>
  );
}
